'use client';

import * as React from 'react';
import { useSelector } from "../../utils/store/index.js";
import { useRenderElement } from "../../utils/useRenderElement.js";
import { useSelectRootContext } from "../root/SelectRootContext.js";
import { selectors } from "../store.js";
const customStyleHookMapping = {
  value: () => null
};

/**
 * A text label of the currently selected item.
 * Renders a `<span>` element.
 *
 * Documentation: [Base UI Select](https://base-ui.com/react/components/select)
 */
export const SelectValue = /*#__PURE__*/React.forwardRef(function SelectValue(componentProps, forwardedRef) {
  const {
    className,
    render,
    children: childrenProp,
    ...elementProps
  } = componentProps;
  const {
    store,
    valueRef
  } = useSelectRootContext();
  const value = useSelector(store, selectors.value);
  const items = useSelector(store, selectors.items);
  const labelFromItems = React.useMemo(() => {
    if (items) {
      if (Array.isArray(items)) {
        return items.find(item => item.value === value)?.label;
      }
      return items[value];
    }
    return null;
  }, [items, value]);
  const state = React.useMemo(() => ({
    value
  }), [value]);
  const children = typeof childrenProp === 'function' ? childrenProp(value) : childrenProp ?? labelFromItems ?? value;
  const element = useRenderElement('span', componentProps, {
    state,
    ref: [forwardedRef, valueRef],
    props: [{
      children
    }, elementProps],
    customStyleHookMapping
  });
  return element;
});
if (process.env.NODE_ENV !== "production") SelectValue.displayName = "SelectValue";